
export const moduleRoutes = {
    register: 'users/',
    getUser: 'users/',
    status: 'users/status/',
    update: 'users/',
    delete: 'users/',
    sync: 'users/synchronize-tableau/',
};
